import React from 'react';
import {useHistory} from "react-router-dom";

export const useListSchedulazioni = () => {

    const history = useHistory();

    const getBottoniDx = () =>
        <button type="button" id="add" name="add"
                className="btn btn-card"
                onClick={() => {
                    history.push(`/upd-schedulazione`);
                }}>
            <i className="fas fa-plus-circle"/> <span className={'cmms-display-mobile'}>Aggiungi Schedulazione</span>
        </button>

    return {getBottoniDx};
};
